import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'

export default {
    namespaced: true,
    state: {
        specimenType : [],
        specimenDecp : [],
    },

    getters: {
    },

    mutations: {
        setSpecimenType (state, specimenType) {
            state.specimenType  = specimenType

        },
        setSpecimenDecp (state, specimenDecp) {
            state.specimenDecp  = specimenDecp

        },


    },

    actions: {
        /* eslint-disable no-console */
        fetchSpecimenType({commit}) {

            return new Promise((resolve,reject) => {
                axios.post(`${getBaseURLforBackEnd()}/api/listofspecimentype`,getConfigAxios())
                    .then((res)=>{
                        commit('setSpecimenType', res.data)
                        resolve(res.data)
                    })
                    .catch((err) =>{
                        reject(err)
                    })
            })
        },

        fetchSpecimenDescp({commit},_id) {

            return new Promise((resolve,reject) => {
                const datTo = {
                    "idspecimen_type" : _id
                }
                axios.post(`${getBaseURLforBackEnd()}/api/listofspecimensdescp`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setSpecimenDecp', res.data)
                        resolve(res.data)
                    })
                    .catch((err) =>{
                        reject(err)
                    })

            })
        }

    }
}